import apiResponseApi from '@/api/responseApi';

const defaultState = () => ({
	responseApiData: [],
	responseApiDetail: {},
	responseApiPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setResponseApi(state, data) {
		state.responseApiData = data.data
		state.responseApiPagination = data.pagination;
	},
	setResponseApiDetail(state, data) {
		state.responseApiDetail = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataResponseApi(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getResponseApi({ commit, dispatch }, params) {
		apiResponseApi.getDataResponseApi(params).then(({ data: { data } }) => {
			commit('setResponseApi', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setResponseApi', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getResponseApiEcommerce({ commit, dispatch }, params) {
		apiResponseApi.getDataResponseApiEcommerce(params).then(({ data: { data } }) => {
			commit('setResponseApi', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setResponseApi', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	setDetailResponseApi({ commit }, params) {
		commit('setResponseApiDetail', params);
	},
	success({ commit }, data) {
		commit("saveResponse", data);
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};